import { create } from "zustand";

interface cacheState {
    // toggleLoading: (toggle: boolean) => void;
    isLoading: boolean;
}

const useCache = create<cacheState>()((set) => ({
    // toggleLoading: (toggle) => set(() => ({ isLoading: toggle })),
    isLoading: false,
}));

export default useCache;
